import { useState } from "react";
import { useAuth } from "../../Providers/AuthProvider";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import Input from "../../common/Input";
import { ChangePassService } from "../../services/ChangePass";
import { useUser } from "../../Providers/UserProvider";
import Spinner from "../spinner/Spinner";

const ChangePassword = ({ handleCloseModal }) => {
  const [loading, setLoading] = useState(true);
  const { stateAuth } = useAuth();
  const initialValues = {
    oldpass: "",
    newpass: "",
    newpassRepeat: "",
  };

  const validationSchema = Yup.object({
    oldpass: Yup.string().required("لطفا رمز عبور قدیم را وارد کنید"),
    newpass: Yup.string()
      .required("لطفا رمز عبور جدیدتان را وارد نمایید")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "رمز عبور شما باید دارای 8 کارکتر شامل عدد، حروف کوچک و بزرگ انگلیسی و یک کارکتر خاص باشد"
      ),
    newpassRepeat: Yup.string()
      .required("لطفا رمز عبور جدید خود را تکرار نمایید.")
      .oneOf(
        [Yup.ref("newpass"), null],
        "رمز عبور جدید با رمز عبور جدید تکرار شده مطابقت ندارد"
      ),
  });
  const onSubmit = async (values) => {
    const { oldpass, newpass } = values;
    const userData = {
      oldpass,
      newpass,
    };
    try {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      console.log(userData);
      console.log(header);
      const { data } = await ChangePassService(userData, header);
      toast.success(`رمز عبور شما با موفقیت تغییر یافت`);
      handleCloseModal();
      formik.resetForm();
    } catch (error) {
      if (error.response && error.response.data.message) {
        //setError(error.response.data.message);
        toast.error("خطایی رخ داده است");
      }
    }
  };
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });
  return (
    <form
      className="flex flex-wrap justify-start"
      onSubmit={formik.handleSubmit}
    >
      <div className="mx-auto p-4 rounded-md w-full">
        <div>
          <h3>تغییر رمز عبور</h3>
        </div>
        <div className="flex flex-col mt-4">
          <div className="flex w-full md:w-full px-3 my-1">
            <Input
              formik={formik}
              name="oldpass"
              label="گذرواژه قبلی"
              type="text"
            />
          </div>
          <div className="flex w-full md:w-full px-3 my-1">
            <Input
              formik={formik}
              name="newpass"
              label="گذرواژه جدید"
              type="text"
            />
          </div>
          <div className="flex w-full md:w-full px-3 my-1">
            <Input
              formik={formik}
              name="newpassRepeat"
              label="تکرار گذرواژه جدید"
              type="text"
            />
          </div>
          <div className="flex w-full md:w-full px-3 gap-4">
            <button
              onClick={handleCloseModal}
              type="button"
              className={`bg-red-600 text-white text-center rounded-md py-2 px-4`}
            >
              انصراف
            </button>
            <button
              type="submit"
              disabled={!formik.isValid}
              className={`disabled:bg-lightGrayKite disabled:text-white disabled:cursor-not-allowed bg-darkGreenKite text-white text-center rounded-md py-2 px-4`}
            >
              {formik.isSubmitting ? <Spinner /> : "تغییر گذر واژه"}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ChangePassword;
